import { isSsr } from './ssr';

export const encodeToBase64 = (str) =>
  isSsr ? new Buffer(str).toString('base64') : window.btoa(unescape(encodeURIComponent(str)));
export const decodeBase64 = (str) =>
  isSsr ? new Buffer(str, 'base64').toString('utf8') : decodeURIComponent(escape(window.atob(str)));
